<template>
  <div id='index'>

    <!-- 轮播和轮播的文案 -->
    <IndexContent></IndexContent>

  </div>
</template>
<script>
import IndexContent from '../components/index/IndexContent'
export default {
  name: 'index',
  data() {
    return {
      bottom: '400px',
    }
  },
  components: {
    IndexContent,
  },
  mounted() {
    // if(window.location.pathname==='/index'){
    //   console.log(window.location.pathname);
    // }
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/Index.vue